import React from 'react';
import Image from "react-bootstrap/Image";

import Header from './Header';
import Footer from './Footer';
import '../Estilos/Estilo.scss';
import { Accordion } from 'react-bootstrap';


export default class About extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lineasInvestigacion: [],
			loading: true,
			cardClass: 'blog-card',


		};

	}
	render() {
		const windowWidth = window.innerWidth;
		const isDesktop = windowWidth > 600;
		return (
			<div className="about-page">
				<Header />
				<tr>
					<div className="content-about">
						{isDesktop ?
							<p>
								<img src="assets/img/photos/grys/GRyS-2023.jpg" align="left" />

								We are a consolidated group of experienced and knowledgeable researchers, as well as promising young scholars, with a diverse set of expertise in Cyber-Physical Systems (CPS), Internet of Things, cooperative robotics, wireless sensors and actuators networks (WSAN), advanced software architectures, distributed applications and middleware systems, high performance and fault-tolerant resilient systems, semantic middleware, adaptive systems, decision support systems, cloud and edge computing.
								<br /><br />
								Our group comprises 9 professors, 1 predoctoral fellow, 2 interns, and 1 administrative staff, providing us with a solid foundation to address some of the most pressing challenges and opportunities in our field. We have a strong track record of participation in both national and international research projects, with some of them being led by us as project coordinators. We have also published over a hundred papers in JCR-indexed journals, as well as several conference papers and book chapters.
								<br /><br />
								In addition to academic excellence, we are also committed to the practical applications of our research. We have registered the intellectual property of some of the software products that have been developed as part of our research activities, and have released some of them as open source developments. We believe that this approach not only contributes to the advancement of the field, but also provides tangible benefits to society by making the technology more accessible and useful to a wider audience.
							</p> :
							<div>
								<img src="assets/img/photos/grys/GRyS-2023.jpg" align="left" />
								<Accordion>
									<Accordion.Item eventKey="0">
										<Accordion.Header>Who we are?</Accordion.Header>
										<Accordion.Body>
											We are a consolidated group of experienced and knowledgeable researchers, as well as promising young scholars, with a diverse set of expertise in Cyber-Physical Systems (CPS), Internet of Things, cooperative robotics, wireless sensors and actuators networks (WSAN), advanced software architectures, distributed applications and middleware systems, high performance and fault-tolerant resilient systems, semantic middleware, adaptive systems, decision support systems, cloud and edge computing.
											<br /><br />
											Our group comprises 9 professors, 1 predoctoral fellow, 2 interns, and 1 administrative staff, providing us with a solid foundation to address some of the most pressing challenges and opportunities in our field. We have a strong track record of participation in both national and international research projects, with some of them being led by us as project coordinators. We have also published over a hundred papers in JCR-indexed journals, as well as several conference papers and book chapters.
											<br /><br />
											In addition to academic excellence, we are also committed to the practical applications of our research. We have registered the intellectual property of some of the software products that have been developed as part of our research activities, and have released some of them as open source developments. We believe that this approach not only contributes to the advancement of the field, but also provides tangible benefits to society by making the technology more accessible and useful to a wider audience.

										</Accordion.Body>
									</Accordion.Item>
									</Accordion>
							</div>}
					</div>
				</tr>
				<hr />
				<h4>GRyS works in the following research areas</h4>
				<hr />
				{this.state.lineasInvestigacion.map(({ title, image, description }) => {

					return (

						<div class={this.state.cardClass} on >
							{isDesktop ?
							<div class="meta">
							<div class="photo"><img src={image}/></div>
						</div>:null}
							<div class="description">
								<h1>{title}</h1>
								<p>{description}</p>
							</div>
						</div>

					);
				})}

				<Footer />
			</div>
		)
	}
	componentDidMount() {
		window.scrollTo(0, 0);
		fetch(process.env.PUBLIC_URL + "/assets/json/research-areas.json").then(res => res.json()).then(lineasInvestigacion => this.setState({ lineasInvestigacion, loading: false }));

	}
}